<template>
	<div>
		<canvas ref="canvas"></canvas>
	</div>
</template>

<script>
	import { Bar, mixins } from 'vue-chartjs';
	const { reactiveProp } = mixins;

	export default {
		props: ['options'],
		extends: Bar,
		mixins: [reactiveProp],
		watch: {
			options() {
				this.update()
			},
		},
		mounted () {
			// this.chartData is created in the mixin.
			// If you want to pass options please create a local options object
			this.renderChart(this.chartData, this.options)
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/charts/basics/BarChart.vue